import * as urls from './urls';
import { removeBannerSetPermission } from './removeBannerSetPermission';
import { setBannerSetPermission } from './setBannerSetPermission';
import { fetchBannerSetsFromNuxeo } from './fetchBannerSetsFromNuxeo';

export { urls, removeBannerSetPermission, setBannerSetPermission, fetchBannerSetsFromNuxeo };
